import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Kicker, H2 } from './ui/Typography';
import { CONFIG } from '../config';
import { useT } from '../i18n/LanguageContext';
export function ProductRevealSection() {
  const {
    product
  } = CONFIG;
  const t = useT().productReveal;
  return <Section hasOrb={true} className="py-24 sm:py-32" data-id="element-166">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-167">
        <div data-id="element-168">
          <Kicker data-id="element-169">{t.kicker}</Kicker>
          <H2 data-id="element-170">
            {t.title1} <span className="text-brand" data-id="element-171">{t.title2}</span>
          </H2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5
        }} className="text-ink-dim text-lg sm:text-xl leading-relaxed mb-8" data-id="element-172">
            {t.desc}
          </motion.p>
          <motion.ul initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="space-y-3 mb-10" data-id="element-173">
            {t.bullets.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink" data-id="element-174">
                <span className="text-brand font-bold mt-1" data-id="element-175">+</span>
                <span data-id="element-176">{item}</span>
              </li>)}
          </motion.ul>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col items-start gap-3" data-id="element-177">
            <Button testId="reveal-cta" className="w-full sm:w-auto" scrollTo="offer" data-id="element-178">
              {t.cta}
            </Button>
            <p className="text-ink-dim text-sm" data-id="element-179">
              <span className="line-through opacity-50 mr-2" data-id="element-180">
                ${product.compareAtPrice}
              </span>
              {t.priceNote}
            </p>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="relative flex items-center justify-center order-first lg:order-last" data-id="element-181">
          <div className="absolute pointer-events-none" style={{
          width: '90%',
          height: '85%',
          background: 'radial-gradient(ellipse, rgba(250,255,0,0.3) 0%, rgba(250,255,0,0.08) 40%, rgba(250,255,0,0) 70%)',
          filter: 'blur(60px)',
          zIndex: 0
        }} data-id="element-182" />
          <img src={product.mockupUrl} alt={product.name} className="relative z-10 w-full max-w-md lg:max-w-lg h-auto" style={{
          filter: 'drop-shadow(0 40px 80px rgba(0,0,0,0.6))'
        }} data-id="element-183" />
        </motion.div>
      </div>
    </Section>;
}